/**
 * Locale 常量与解析（00 开发文档：locale 仅接受 zh-CN | en）。
 * 路由形态 /{locale}/...（工程化取代原型 ?lang= 决策 3）。
 */
import type { Locale } from '@chronospeak/contracts';

export const locales = ['zh-CN', 'en'] as const satisfies readonly Locale[];
export const defaultLocale: Locale = 'zh-CN';

export function isLocale(value: string | undefined): value is Locale {
  return locales.includes(value as Locale);
}

/** 从 URL pathname 提取 locale（/en/builders → 'en'；无前缀 → null） */
export function localeFromPathname(pathname: string): Locale | null {
  const seg = pathname.split('/')[1];
  return isLocale(seg) ? seg : null;
}
